import type { SVGProps } from 'react';

const StepCompleteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 25 25" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0ZM17.2174 10.1666C17.6546 9.63228 17.5759 8.84475 17.0415 8.40759C16.5072 7.97043 15.7197 8.04918 15.2826 8.58349L10.5322 14.3895L9.00888 12.8662C8.52073 12.378 7.72927 12.378 7.24112 12.8662C6.75296 13.3543 6.75296 14.1458 7.24112 14.6339L9.74112 17.1339C9.99084 17.3836 10.3345 17.5161 10.6873 17.4985C11.04 17.4809 11.3688 17.3149 11.5924 17.0416L17.2174 10.1666Z"
      fill="#4B7EFF"
    />
  </svg>
);

export default StepCompleteIcon;
